import { createFileRoute } from "@tanstack/react-router";
import { HomePage, homeHead } from "@/pages/HomePage";

export const Route = createFileRoute("/")({
  head: () => homeHead("da"),
  component: () => <HomePage locale="da" />,
});
